import { getAmplitudeInstance } from '../amplitudeHelpers';
import ListContentType from '../enums/ListContentType';

type logListItemRemovedParams = {
  list_id?: string;
  list_item_type: string;
  list_type?: ListContentType;
  map_id?: string;
  trail_id?: string;
};

/**
 * The user has removed an item from a list.
 * @param params - Attributes to log with the amplitude event
 * @param params.list_id - Id of the list the item was removed from.
 * @param params.list_item_type - Type of item removed from the list (map, trail, recording).
 * @param params.list_type - Type of list the item was removed from.
 * @param params.map_id - Id of the map removed, if applicable.
 * @param params.trail_id - Id of the trail removed, if applicable.
 */
const logListItemRemoved = ({ list_id, list_item_type, list_type, map_id, trail_id }: logListItemRemovedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'list item removed',
    { 'list id': list_id, 'list item type': list_item_type, 'list type': list_type, 'map id': map_id, 'trail id': trail_id },
    callback
  );
};

export default logListItemRemoved;
